import { Grid } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

export const PayoutSummaryConditionsHeader = () => {
  const { isMobile } = useScreen();

  return (
    <Grid container justifyContent="flex-end">
      {!isMobile && (
        <Grid item xs={3} style={{ paddingLeft: 6, textAlign: 'end' }}>
          <Font variant={isMobile ? 'caption' : 'body2'} color="textPrimary">
            <strong>
              <Text tId={'TRANSACTIONS'} />
            </strong>
          </Font>
        </Grid>
      )}
      <Grid item xs={3} style={{ paddingLeft: 6, textAlign: 'end' }}>
        <Font variant={isMobile ? 'caption' : 'body2'} color="textPrimary">
          <strong>
            <Text tId={'AMOUNT'} />
          </strong>
        </Font>
      </Grid>
    </Grid>
  );
};
